module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Angel Hands")]), _vm._v(" "), _c('p', {
    staticClass: "Top-quote"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("La première Ève fut ensevlie hors du jarden")])]), _vm._v(" "), _c('p', {
    staticClass: "Top-quote-source"
  }, [_vm._v("Charles Pèguy")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Held by angels")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("we’re beckoned")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("into unwalled gardens")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("welcomed in our body-selves")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("us, cobbers, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("ineinander")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("night homecoming")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of daylight strangers,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("now winging it,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("intertwined, unafraid")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("young and old gifted")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("with angel hands")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("giving and forgiving.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-101070ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-9.vue
// module id = 84
// module chunks = 0